"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlHeaders = exports.buildAllHeaders = exports.buildOptions = void 0;
const constants_1 = require("./constants");
const headers_1 = require("./headers");
const utils_1 = require("./utils");
const buildOptions = ({ requestOptions, urlObject, headers, globalConfig = {
    httpMockServer: {
        enabled: false,
    },
}, }) => {
    const { url, params } = requestOptions;
    if (params) {
        if (typeof params !== 'object') {
            throw new Error('Search params must be an object');
        }
    }
    const localConfigOptions = maybeRedirectToMockServer(url, globalConfig);
    const newOptions = Object.assign(Object.assign(Object.assign({}, requestOptions), localConfigOptions), { headers });
    return newOptions;
};
exports.buildOptions = buildOptions;
const buildAllHeaders = (requestOptions, wixHeadersOpts, globalConfig = {
    httpMockServer: {
        enabled: false,
    },
}, urlObject) => {
    const { url, disableWixHeaders, headers } = requestOptions;
    const composedHeaders = (0, headers_1.composeHeaders)({
        url,
        disableWixHeaders,
        wixHeadersOpts,
    });
    const originalUrlHeader = (0, exports.getUrlHeaders)(globalConfig, requestOptions, urlObject);
    return Object.assign(Object.assign(Object.assign({}, composedHeaders), lowerAllJsonKeys(headers)), originalUrlHeader);
};
exports.buildAllHeaders = buildAllHeaders;
const getUrlHeaders = (globalConfig, requestOptions, urlObject) => {
    const { url, params } = requestOptions;
    const { host, protocol } = urlObject;
    const originalUrlHeader = globalConfig.httpMockServer.enabled
        ? {
            [constants_1.ORIGINAL_URL_HEADER]: buildUrlFromRequest(url, params),
            [constants_1.ORIGINAL_HOST_HEADER]: (0, utils_1.isAbsoluteUrl)(url) ? (0, utils_1.extractHost)(url) : host,
            [constants_1.ORIGINAL_PROTOCOL_HEADER]: (0, utils_1.isAbsoluteUrl)(url)
                ? (0, utils_1.extractProtocol)(url)
                : protocol,
        }
        : {};
    return originalUrlHeader;
};
exports.getUrlHeaders = getUrlHeaders;
function maybeRedirectToMockServer(url, globalConfig) {
    if (globalConfig.httpMockServer.enabled) {
        const mockUrl = new URL(globalConfig.httpMockServer.mockServerUrl);
        return {
            url: (0, utils_1.changeHost)(url, mockUrl.host),
        };
    }
    return {};
}
function buildUrlFromRequest(url, requestParams) {
    const { pathname, searchParams } = new URL(url, 'http://unused.com');
    requestParams = requestParams || searchParams;
    if (requestParams) {
        const params = (0, utils_1.toSearchQueryParams)(requestParams) || requestParams.toString();
        const paramsAsString = params ? `?${params}` : '';
        return `${pathname}${paramsAsString}`;
    }
    return pathname;
}
function lowerAllJsonKeys(objectToChange) {
    objectToChange = objectToChange || {};
    const result = Object.keys(objectToChange).reduce((prev, key) => (Object.assign(Object.assign({}, prev), { [key.toLowerCase()]: objectToChange[key] })), {});
    return result;
}
//# sourceMappingURL=options.js.map